// extracted by mini-css-extract-plugin
module.exports = {"holder":"HomePage_holder__fDYiU","footer":"HomePage_footer__2Zu23","footerHided":"HomePage_footerHided__2LYZ6"};